function AdminApplyStepAccount({ user, onContinue, onUseDifferentEmail }) {
  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-lg font-medium text-slate-700">Confirm your account</h2>
      <p className="text-sm text-slate-400">
        You're signed in as <span className="font-medium text-slate-700">{user.email}</span>.
      </p>

      <p className="text-sm text-slate-400">
        If you are requesting gallery access, we recommend signing in or signing up with{' '}
        <span className="font-medium text-slate-600">a gallery-affiliated email</span> (not a
        personal account) — it helps us approve your request faster and makes it easier for your
        team to collaborate on the same account.
      </p>

      <div className="flex flex-wrap justify-end gap-2 mt-2">
        <button
          type="button"
          className="btn btn-outline btn-sm focus:outline-none"
          onClick={onUseDifferentEmail}
        >
          Sign in with a different email
        </button>
        <button
          type="button"
          className="btn btn-primary btn-sm focus:outline-none"
          onClick={onContinue}
        >
          Continue
        </button>
      </div>
    </div>
  );
}

export default AdminApplyStepAccount;
